import { BaseModel } from './base.model'
import includes from 'lodash-es/includes'
import some from 'lodash-es/some'

export class UploadedFile extends BaseModel {
  id: number | string
  name: string
  displayName: string
  path: string
  createdAt: string
  createdById: number
  extension: string
  type?: UploadedFileType
  teamId?: string | number
  remotePath?: string
  mimeType?: string
  original?: UploadedFile
  url: string
  isStored: boolean

  constructor(src?: UploadedFile) {
    super(src)
    const imageFormats = ['.jpeg', '.png', '.jpg']
    const isImage = (format) => includes(this.name, format)

    this.type = some(imageFormats, isImage) ? UploadedFileType.Image : UploadedFileType.Document
    this.path = this.path && this.fileUrl + this.path
  }
}

export enum UploadedFileType {
  Image = 'image',
  Document = 'document',
}

export interface TypesImage {
  title: string
  translateValue: string
  picture: string
  defaultPicture: string
}
